export default __webpack_public_path__ + "static/media/hht2_ep20_timeline_q04_b.4393e05f.png";